<template>
    <div class="m15" ref="body" style="page-break-before: always;">
        <hr />
        <h4 class="simulator-title loaded">{{ titulo }}</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <br />

        <div class="texto">
            Diante de um cenário de incertezas com relação ao nosso <b>futuro</b>, fica a cada dia mais evidente a necessidade de implantarmos um correto
            <b>planejamento financeiro</b> para alcançarmos uma&nbsp;
            <b> aposentadoria</b>
            com <b>dignidade</b> ou a nossa <b>liberdade financeira</b>.
        </div>
        <div class="row">
            <div class="col l12 s12">
            <div
                class="texto"
                style="text-align:justify"
            >O Brasil passa por uma <b style="font-weight:bold;">mudança demográfica</b> acelerada, com uma redução expressiva da taxa de fecundidade e ao mesmo tempo uma maior expectativa de vida da população, hoje já somos mais de 30.000 pessoas com mais de 100 anos de vida. A formação de uma <b style="font-weight:bold;">reserva futura</b> para suprir nossas necessidades, atuando como uma complementação dos benefícios da Previdência Social, tornou-se item fundamental para nossa sobrevivência.</div>
            </div>
        </div>
        <div class="row">
            <div class="col l12 s12">
            <div
                class="texto"
                style="text-align:justify"
            >Ao mesmo tempo em que estamos construindo o nosso <b style="font-weight:bold;">futuro financeiro</b>, nossas reservas e patrimônio, faz-se necessário a <b style="font-weight:bold;">gestão dos riscos</b> que podem afetar esse nosso planejamento. A <b style="font-weight:bold;">gestão</b> desses <b style="font-weight:bold;">riscos</b> funciona como o alicerce, a fundação, em um processo de construção, ela lhe trará a segurança e tranquilidade necessárias contra imprevistos.</div>
            </div>
        </div>
        <div class="row">
            <div class="col l12 s12">
            <div
                class="texto"
                style="text-align:justify"
            >Diante do cenário acima e baseados nas informações colhidas durante o nosso processo de <b style="font-weight:bold;">consultoria pessoal</b>, apresentamos abaixo um breve resumo de sua situação atual, os riscos e as suas necessidades de cobertura.</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import PieChart from '@/components/canvas-chart/PieChart'
    import PieChart2 from '@/components/canvas-chart/PieChart2'
    import Saudacao from './Saudacao'
    export default {
        name:'PatrimonioTotal',
        mixins: [utils],
        components:{
            PieChart,
            PieChart2,
            Saudacao
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
            empresa_selecionada: {
                type: Object,
                default: null
            }
        },
        data () {
            return {
                titulo: 'Introdução',
            }
        },
        methods: {

            async plot(){

                return `<div class="m15 page_logo" ref="body" id="introducao" style="page-break-before: always;">
                        <div class="site"></div>
                        <h4 class="simulator-title loaded">Introdução</h4>
                         ${this.$refs.saudacao.plot()}
                        <div >
                            <table>
                                <tr>
                                    <td width="100%" style="vertical-align: top;">

                                        <p class="texto justify">Diante de um cenário de incertezas com relação ao nosso <b style="font-weight:bold;">&nbsp;futuro</b>, fica a cada dia mais evidente a necessidade de implantarmos um correto <b style="font-weight:bold;">planejamento financeiro</b> para alcançarmos uma <b style="font-weight:bold;">&nbsp;aposentadoria</b> com <b style="font-weight:bold;">dignidade</b> ou a nossa <b style="font-weight:bold;">liberdade financeira</b>.</p>

                                        <p style="font-size:18px;padding-bottom:30px; display: ${this.empresa_selecionada.nome === 'Mais Previdencia' ? 'block': 'none'}">
                                            A MAIS PREVIDÊNCIA, a sua entidade de previdência complementar, uma entidade sem fins
                                            lucrativos, busca, com a sua Consultoria em Proteção e Planejamento Financeiro, apresentar
                                            um Diagnóstico de sua situação atual, identificando necessidades e apresentando as melhores
                                            soluções.
                                        </p>

                                        <p style="font-size:18px;padding-bottom:30px;">O Brasil passa por uma <b style="font-weight:bold;">mudança demográfica</b> acelerada, com uma redução expressiva da taxa de fecundidade e ao mesmo tempo uma maior expectativa de vida da população, hoje já somos mais de 30.000 pessoas com mais de 100 anos de vida. A formação de uma <b style="font-weight:bold;">reserva futura</b> para suprir nossas necessidades, atuando como uma complementação dos benefícios da Previdência Social, tornou-se item fundamental para nossa sobrevivência.</p>

                                        <p style="font-size:18px;padding-bottom:30px;">Ao mesmo tempo em que estamos construindo o nosso <b style="font-weight:bold;">&nbsp;futuro financeiro</b>, nossas reservas e patrimônio, faz-se necessário a <b style="font-weight:bold;">gestão dos riscos</b> que podem afetar esse nosso planejamento. A <b style="font-weight:bold;">gestão</b> desses <b style="font-weight:bold;">riscos</b> funciona como o alicerce, a fundação, em um processo de construção, ela lhe trará a segurança e tranquilidade necessárias contra imprevistos.</p>

                                        <p style="font-size:18px;">Diante do cenário acima e baseados nas informações colhidas durante o nosso processo de <b style="font-weight:bold;">&nbsp;consultoria pessoal</b>, apresentamos abaixo um breve resumo de sua situação atual, os riscos e as suas necessidades de cobertura.</p>

                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>`;

            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
*{ color-adjust: exact; -webkit-print-color-adjust: exact; }
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.apexcharts-legend{
    justify-content: space-around!important;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 100%;
    }
}
@media (min-width: 768px) and (max-width:938px){

}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/PatrimonioTotal.vue